var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H3.4C2.07 13 1 11.93 1 10.6V3.4C1 2.07 2.07 1 3.4 1H10.6C11.93 1 13 2.07 13 3.4V4M9.4 7H16.6C17.2365 7 17.847 7.25286 18.2971 7.70294C18.7471 8.15303 19 8.76348 19 9.4V16.6C19 17.2365 18.7471 17.847 18.2971 18.2971C17.847 18.7471 17.2365 19 16.6 19H9.4C8.76348 19 8.15303 18.7471 7.70294 18.2971C7.25286 17.847 7 17.2365 7 16.6V9.4C7 9.08483 7.06208 8.77274 7.18269 8.48156C7.3033 8.19038 7.48008 7.9258 7.70294 7.70294C7.9258 7.48008 8.19038 7.3033 8.48156 7.18269C8.77274 7.06208 9.08483 7 9.4 7Z",
    stroke: "#034A73",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a8f438f1c52945d655f3e9d5b49927a0.svg";
export { ForwardRef as ReactComponent };